import script from "./Confetti.vue?vue&type=script&lang=ts&setup=true"
export * from "./Confetti.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__